import { render, staticRenderFns } from "./IconAwful.vue?vue&type=template&id=32d7ef1d&scoped=true"
import script from "./IconAwful.vue?vue&type=script&lang=js"
export * from "./IconAwful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7ef1d",
  null
  
)

export default component.exports